import { Grid } from "@material-ui/core";
import { Add, Room } from "@material-ui/icons";
import _ from "lodash";
import React, { FC, useState } from "react";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { LocationViewModel } from "../../model/LocationViewModel";
import TitleWithIcon from "../common/TitleWithIcon";
import CustomButton from "../common/buttons/CustomButton";
import RightButtonArea from "../common/buttons/RightButtonArea";
import LocationCard from "../location/LocationCard";
import TranslatedMessage from "../translations/TranslatedMessage";
import LocationSelectionDialog from "./LocationSelectionDialog";

type ExamSessionLocationListProps = {
  examSessionLocations: LocationViewModel[];
  allLocations: LocationViewModel[];
  isReadOnly: boolean;
  onAssigningLocations: (locationIds: string[]) => void;
  onRemovingLocation: (locationId: string) => void;
  onLocationCardSelected: (locationId: string) => void;
  className?: string;
} & WrappedComponentProps;

const isLocationAssigned = (assignedLocations: LocationViewModel[], locationId: string) => {
  if (assignedLocations.find((location) => location.id === locationId)) {
    return true;
  }

  return false;
};

const ExamSessionLocationList: FC<ExamSessionLocationListProps> = ({
  intl,
  isReadOnly,
  className,
  examSessionLocations,
  allLocations,
  ...eventHandlers
}) => {
  const selectableLocations = allLocations.filter((location) => !isLocationAssigned(examSessionLocations, location.id));
  const sortedLocations = _.orderBy(examSessionLocations, (location) => location.name.toLowerCase());
  const locationCards = sortedLocations.map((location) => (
    <Grid item={true} xs={12} sm={6} md={4} lg={3} xl={2} key={location.id}>
      <LocationCard
        isDeleteButtonVisible={!isReadOnly}
        location={location}
        onClick={eventHandlers.onLocationCardSelected}
        onDeleteClick={() => eventHandlers.onRemovingLocation(location.id)}
      />
    </Grid>
  ));

  const handelNewLocationSelection = (selectedLocations: LocationViewModel[]) => {
    var selectedLocationIds = selectedLocations.map((location) => location.id);
    setSelectionDialogOpened(false);
    eventHandlers.onAssigningLocations(selectedLocationIds);
  };

  const [selectionDialogOpened, setSelectionDialogOpened] = useState(false);

  return (
    <>
      <Grid container={true} spacing={isReadOnly ? 2 : 0}>
        <Grid item={true} container={true} alignItems="center">
          <Grid item={true} xs={12} sm={6}>
            <TitleWithIcon title={<TranslatedMessage id="location.header" />} variant="h5">
              <Room fontSize="small" />
            </TitleWithIcon>
          </Grid>

          {!isReadOnly && (
            <Grid item={true} xs={12} sm={6}>
              <RightButtonArea>
                <CustomButton
                  tooltip={<TranslatedMessage id="location.button.new" />}
                  onClick={() => setSelectionDialogOpened(true)}
                >
                  <Add />
                </CustomButton>
              </RightButtonArea>
            </Grid>
          )}
        </Grid>

        <Grid item={true} container={true} spacing={2}>
          {locationCards}
        </Grid>
      </Grid>
      <LocationSelectionDialog
        handleAccept={handelNewLocationSelection}
        handleCancel={() => setSelectionDialogOpened(false)}
        isOpened={selectionDialogOpened}
        locations={selectableLocations}
      />
    </>
  );
};

ExamSessionLocationList.defaultProps = {
  onAssigningLocations: (_locationIds: string[]) => {},
  onRemovingLocation: (_locationId: string) => {},
  onLocationCardSelected: (_locationId: string) => {},
} as Partial<ExamSessionLocationListProps>;

export default injectIntl(ExamSessionLocationList);
